import { EditFilled } from '@ant-design/icons';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { StaticInput } from '@framework/form/inputs/static/StaticInput.tsx';
import { Button, Space } from 'antd';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { SelectWidgetWrapper } from '../common/select-widget/SelectWidgetWrapper.tsx';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { type IAsyncSelectWidget } from './IAsyncSelectWidget.ts';

const FullWidthCompact = styled(Space.Compact)`
  width: 100%;
`;

export interface IAsyncSelectWidgetPreviewProps
  extends IWidgetComponentProps<IAsyncSelectWidget> {}

export function AsyncSelectWidgetPreview(
  props: IAsyncSelectWidgetPreviewProps,
) {
  const { widget } = props;
  const options = getWidgetProps(props);

  if (widget.renderType === 'table') {
    return (
      <ConfigFormItem
        name={'string'}
        label={<RichTextAdvancedRender inline text={options.label} />}
        help={
          options.helpText ? (
            <RichTextAdvancedRender inline text={options.helpText} />
          ) : undefined
        }
        layout={{ hideVisualLabel: options.hideLabel }}
        readonly={options.readonly}
        widget={props.widget}
      >
        <FullWidthCompact>
          <StaticInput value={''} placeholder={options.placeholder} />
          <Button
            size="large"
            type="primary"
            style={{ width: '130px' }}
            icon={<EditFilled />}
          >
            Scegli
          </Button>
        </FullWidthCompact>
      </ConfigFormItem>
    );
  }

  return (
    <SelectWidgetWrapper {...props} widget={widget}>
      <SelectInput
        name={'async-select-widget'}
        placeholder={options.placeholder}
      />
    </SelectWidgetWrapper>
  );
}
